import React from "react";
import PaymentSubscribePlan from "./PaymentSubscribePlan";
import PaymentResultScreen from "./PaymentResultScreen";
import { PaymentSectionProps } from "types/subscriptionAndPlans";

const PaymentStepContent: React.FC<PaymentSectionProps> = ({
  paymentSuccess,
  screen,
  isScreenLoading,
  errrorMessage,
  id,
  newProducts,
  currentPlan,
  amount,
  isManualForm,
  setHandleDrawerSize,
  setIsPreview,
  setIsPreviewId,
  onClose,
  updateRef,
  setIsManualForm,
  setPaymentSuccess,
  setCurrentStep,
  setScreen,
}) => {
  if (isScreenLoading) {
    return (
      <div className="h-full max-h-[var(--shell-vh)] flex justify-center items-center">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-solid border-blue border-r-transparent align-[-0.125em] text-primary motion-reduce:animate-[spin_1.5s_linear_infinite]"></div>
      </div>
    );
  }

  if (paymentSuccess) {
    return (
      <PaymentResultScreen
        screen={screen}
        errrorMessage={errrorMessage}
        id={id}
        setHandleDrawerSize={setHandleDrawerSize}
        setIsPreview={setIsPreview}
        setIsPreviewId={setIsPreviewId}
        onClose={onClose}
      />
    );
  }

  const isDowngradePlan = amount <= 0;

  return (
    <PaymentSubscribePlan
      id={id}
      newProducts={newProducts}
      currentPlan={currentPlan}
      amount={amount}
      setPaymentSuccess={setPaymentSuccess}
      setCurrentStep={setCurrentStep}
      setScreen={setScreen}
      isManualForm={isManualForm}
      setIsManualForm={setIsManualForm}
      ref={updateRef}
      isDowngradePlan={isDowngradePlan}
    />
  );
};

export default PaymentStepContent;
